require('../../modules/es.reflect.to-string-tag');

module.exports = 'Reflect';
